import facebook from "../../../Assets/Img/facebook.png";
import utube from "../../../Assets/Img/utube.png";
import linkdin from "../../../Assets/Img/linkdin.png";
import graduate from "../../../Assets/Img/Graduate.png";
import whatsppp from "../../../Assets/Img/whatsppp.png";
import handImg from "../../../Assets/Img/handImg.webp";
import tech from "../../../Assets/Img/tech.jpg";
import girl from "../../../Assets/Img/girl.png";
import mobile from "../../../Assets/Img/mobile.png";
import hapyGirl from "../../../Assets/Img/hapyGirl.png";
import arrow from "../../../Assets/Img/newarrow.png";
import arrowBlack from "../../../Assets/Img/newarrowblack.png";
import cloud from "../../../Assets/Img/cloud.jpeg";
import manufacture from "../../../Assets/Img/manufacture.jpg";
import inventory from "../../../Assets/Img/inventory.webp";
import testimonial from "../../../Assets/Img/testimonial.png";
import BannerLinks from "../../../subComponent/BannerLinks";
import Footer from "../../../subComponent/Footer";
import backgroundImage from '../../../Assets/Img/Background.png'
import NavBar from "../../../subComponent/NavBar";
import { Navigate, useNavigate } from "react-router-dom";
const Home = () => {
    const navigate = useNavigate()


    return (
        <>

            <div >

                <div className="Section_1 w-100 m-0 row ">
                    <NavBar />

                    <div className=" col-12 col-md-6 p-3 mt-5 p-md-5">

                        <p className="norwester fs_7 text-white">SMARTB SOLUTIONS</p>
                        <p className="Roboto fs_4 text-white">You Focus on The Business,<br /> We'll Focus On The Technology</p>

                        <div className='line1 mt-5 bg-white w-100'></div>

                    </div>
                    <div className='col-12 col-md-6  d-flex justify-content-center align-items-center position-relative my-3 my-md-5 pt-3 pt-md-5 ' >
                        <img src={handImg} className='position-md-absolute handImg' alt="" />
                    </div>
                    <div className="col-12">
                        <div className='d-inline-flex col-6 px-4 my-3 my-md-0'>
                            <img src={facebook} className='logoSize mx-1' alt="" />
                            <img src={utube} className='logoSize mx-1' alt="" />
                            <img src={linkdin} className='logoSize mx-1' alt="" />
                            <img src={graduate} className='logoSize mx-1' alt="" />
                            <img src={whatsppp} className='logoSize mx-1' alt="" />
                        </div>
                    </div>

                </div>

                <div className='Section_2 w-100 m-0 row'>
                    <div className='col-12 col-md-6 p-3 p-md-5'>
                        <p className='futura fs_10 text-white opacity-75 mb-3 mb-md-0'>Message</p>
                        <p className='futura fs_4 text-decoration-underline text-white fw-500'>Digitize & Grow Your Business Today</p>
                        <p className='futura fs_2 text-white'>Amazon was the first company to create a 1-click ordering.
                            How about you? What are you doing to automate your business today?</p>
                        <div className='d-flex justify-content-center my-3 my-md-0 '>
                            <button className="button button-white" onClick={() => navigate('/Homepage')}>
                                <span className="text text-white fs_2">More</span>
                                <img src={arrow} alt="Image" className="icon" />
                            </button>

                        </div>


                    </div>
                    <div className='col-12 col-md-6 pe-0 pt-5vw'>
                        <div className="CapsulePar Left">

                            <div className="half-capsule">
                                <img src={tech} alt="Your image" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="Section_3 w-100 m-0 row" >
                    <div className='col-12 col-md-6 home-about-section  pt-5vw'>
                        <div className="CapsulePar Right">

                            <div className="half-capsule">
                                <img src={girl} alt="Your image" />
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-md-6 p-3 p-md-5'>
                        <p className='futura fs_10 text-black opacity- mb-3 mb-md-0'>About</p>
                        <p className='futura fs_4 text-decoration-underline text-black fw-500'>We aim to help all our customers become smarter</p>
                        <p className='futura fs_2 text-black'>SmartB is grown from a team of Technology Fanatics who are passionately crazy about helping our customers grow. </p>
                        <div className='d-flex justify-content-center'>
                            <button className="button button-black " onClick={() => navigate('/AboutUs')}>
                                <span className="text text-black fs_2">More</span>
                                <img src={arrowBlack} alt="Image" className="icon" />
                            </button>

                        </div>
                    </div>
                </div>

                <div className='Section_4 w-100 m-0 row py-4'>
                    <div className='col-12 col-md-6 p-3 p-md-5'>
                        <p className='futura fs_10 text-white opacity-75 mb-3 mb-md-0'>Service</p>
                        <p className='futura fs_4 text-decoration-underline text-white fw-500'>We Provide our best services to you</p>
                        <p className='futura fs_2 text-white'>Digital Transformation is a Journey. Our aim is to move SMEs towards this national goals. </p>
                        <div className='d-flex justify-content-center my-3 my-md-0'>
                            <button className="button button-white">
                                <span className="text text-white fs_2">More</span>
                                <img src={arrow} alt="Image" className="icon" />
                            </button>

                        </div>


                    </div>
                    <div className='col-12 col-md-6 pe-0 pt-5vw'>
                        <div className="CapsulePar Left">

                            <div className="half-capsule">
                                <img src={mobile} alt="Your image" />
                            </div>
                        </div>
                    </div>
                    <div className="col-12" >
                        <div className="d-md-flex doubleImg justify-content-around">
                            <div className="AboutImg align-self-start" >
                                <div className="image" style={{ backgroundImage: `url(${cloud})` }}></div>
                                <div className="content">
                                    Cloud-Based System
                                </div>
                            </div>
                            <div className="AboutImg align-self-center">
                                <div className="image" style={{ backgroundImage: `url(${manufacture})` }}></div>
                                <div className="content">
                                    Manufacturing
                                </div>
                            </div>
                            <div className="AboutImg align-self-end" >
                                <div className="image" style={{ backgroundImage: `url(${inventory})` }}></div>
                                <div className="content">
                                    Inventory
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="Section_5 w-100 m-0">
                    <div className="bg-image"></div>
                    <div className="bg-overlay"></div>
                    <div className="container bac position-relative">
                        <p className="fs_8 futura testimonial text-center opacity-50" >Testimonial</p>

                        {/* //qwert */}
                        <div className="testimonial-carousel-wrapper">
                            <span id="item-1"></span>
                            <span id="item-2"></span>
                            <span id="item-3"></span>
                            <div className="testimonial-carousel-item item-1">
                                <p className="testimonial-text poppins fs_30 text-center">“The best thing about SmartB is customization. We do a lot of customization with SmartB to fulfil our manufacturing process.</p>
                                <div className='line1 mt-5 bg-white w-100'></div>
                                <div className="comment-widgets">

                                    {/* <!-- Comment Row --> */}
                                    <div className="d-flex flex-row comment-row m-t-0 px-3 px-md-5 justify-content-center align-items-center">
                                        <div className="p-2"><img src={testimonial} alt="user" width="150" /></div>
                                        <div className="comment-text">
                                            <div className="comment-footer d-flex justify-content-between">
                                                <p className="fs_16 fw-700 float-right mb-0">Ms Chen</p>
                                                <div className="rating">
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star unFilled">★</button>
                                                </div>
                                            </div>
                                            <p className="m-b-15 d-block fs_16">Strategic Planning Manager, Diyou Fibre</p>
                                        </div>
                                    </div>

                                </div>

                                <a className="arrow arrow-prev" href="#item-3"></a>
                                <a className="arrow arrow-next" href="#item-2"></a>
                                <p className="text-end">View All</p>
                                <div className="d-flex justify-content-center align-self-center pb-3 pb-md-0">

                                    <div className="dot active" href="#item-1">
                                        .
                                    </div>
                                    <div className="dot" href="#item-2">
                                        .
                                    </div>
                                    <div className="dot" href="#item-3">
                                        .
                                    </div>
                                </div>
                            </div>

                            <div className="testimonial-carousel-item item-2">
                                <p className="testimonial-text poppins fs_30 text-center">“Second The best thing about SmartB is customization. We do a lot of customization with SmartB to fulfil our manufacturing process.</p>
                                <div className='line1 mt-5 bg-white w-100'></div>

                                <div className="comment-widgets">
                                    {/* <!-- Comment Row --> */}
                                    <div className="d-flex flex-row comment-row m-t-0 px-3 px-md-5 justify-content-center align-items-center">
                                        <div className="p-2"><img src={testimonial} alt="user" width="150" /></div>
                                        <div className="comment-text">
                                            <div className="comment-footer d-flex justify-content-between">
                                                <p className="fs_16 fw-700 float-right mb-0">Ms Chen</p>
                                                <div className="rating">
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star unFilled">★</button>
                                                </div>
                                            </div>
                                            <p className="m-b-15 d-block fs_16">Strategic Planning Manager, Diyou Fibre</p>
                                        </div>
                                    </div>
                                </div>

                                <a className="arrow arrow-prev" href="#item-1"></a>
                                <a className="arrow arrow-next" href="#item-3"></a>
                                <p className="text-end" >View All</p>
                                <div className="d-flex justify-content-center align-self-center pb-3 pb-md-0">

                                    <div className="dot" href="#item-1">
                                        .
                                    </div>
                                    <div className="dot active" href="#item-2">
                                        .
                                    </div>
                                    <div className="dot" href="#item-3">
                                        .
                                    </div>
                                </div>

                            </div>

                            <div className="testimonial-carousel-item item-3">
                                <p className="testimonial-text poppins fs_30 text-center">“Third The best thing about SmartB is customization. We do a lot of customization with SmartB to fulfil our manufacturing process.</p>
                                <div className='line1 mt-5 bg-white w-100'></div>

                                <div className="comment-widgets">

                                    {/* <!-- Comment Row --> */}
                                    <div className="d-flex flex-row comment-row m-t-0 px-3 px-md-5 justify-content-center align-items-center">
                                        <div className="p-2"><img src={testimonial} alt="user" width="150" /></div>
                                        <div className="comment-text">
                                            <div className="comment-footer d-flex justify-content-between">
                                                <p className="fs_16 fw-700 float-right mb-0">Ms Chen</p>
                                                <div className="rating">
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star">★</button>
                                                    <button className="rating__star unFilled">★</button>
                                                </div>
                                            </div>
                                            <p className="m-b-15 d-block fs_16">Strategic Planning Manager, Diyou Fibre</p>
                                        </div>
                                    </div>
                                </div>

                                <a className="arrow arrow-prev" href="#item-2"></a>
                                <a className="arrow arrow-next" href="#item-1"></a>
                                <p className="text-end" >View All</p>
                                <div className="d-flex justify-content-center align-self-center pb-3 pb-md-0">

                                    <div className="dot" href="#item-1">
                                        .
                                    </div>
                                    <div className="dot" href="#item-2">
                                        .
                                    </div>
                                    <div className="dot active" href="#item-3">
                                        .
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="Section_6 w-100 m-0 py-2 py-md-5" >
                <div className="row home-stories ">
                        <div className='col-12 col-md-6  home-stories-section pe-md-0 pt-5vw'>
                            <div className="CapsulePar Right">

                                <div className="half-capsule">
                                    <img src={hapyGirl} alt="Your image" />
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-6 p-4 p-md-5'>
                            <p className='futura fs_10 text-white opacity-75'>Stories</p>
                            <p className='futura fs_4 text-decoration-underline text-white fw-500'>Hear What Our Clients Says</p>
                            <p className='futura fs_2 text-white'>At SmartB, we have our Tech Squad who is dedicated to understanding and designing solutions that meet our client's requirement.</p>
                            <div className='d-flex justify-content-center'>
                                <button className="button button-white">
                                    <span className="text text-white fs_2">More</span>
                                    <img src={arrow} alt="Image" className="icon" />
                                </button>
                            </div>

                        </div>
                    </div>
                    <div className="container py-5">
                        {/* https://youtu.be/fkNr5-OhMVo */}
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <iframe width="100%" height="315" src="https://www.youtube.com/embed/fkNr5-OhMVo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                            </div>

                            <div className="col-12 col-md-6">
                                <iframe width="100%" height="315" src="https://www.youtube.com/embed/rv1W-OmtnXQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                            </div>
                        </div>

                    </div>
                </div>

                <div>
                    <div className="row  faq-section w-100 m-0">
                        <div className="col-12 col-md-6 FAQs_Background background-setting h-40vw d-flex justify-content-center align-items-center flex-column">
                            {/* <div> */}
                            <p className="futura fs_8 text-white lh-100">FAQ</p>
                            <button className="button button-white">
                                <span className="text text-white fs_2">More</span>
                                <img src={arrow} alt="Image" className="icon" />
                            </button>
                            {/* </div> */}
                        </div>
                        <div className="col-12 col-md-6 contact_Background background-setting h-40vw d-flex justify-content-center align-items-center flex-column">
                            {/* <div> */}
                            <p className="futura fs_8 text-white lh-100">Contact</p>
                            <button className="button button-white" onClick={() => navigate('/ContactUs')}>
                                <span className="text text-white fs_2">More</span>
                                <img src={arrow} alt="Image" className="icon" />
                            </button>
                            {/* </div> */}

                        </div>
                    </div>
                    <div>
                        <BannerLinks />
                    </div>
                </div>
                <div className="background-setting py-5" style={{ backgroundImage: `url(${backgroundImage})` }}>
                    <Footer />
                </div>
            </div>
        </>
    );
}

export default Home;